// Общие примитивы цветовой индикации для select-компонентов (SimpleSelectInput,
// SimpleMultiSelectInput): валидация HEX-цвета из данных и сам индикатор (сволч).
// Вынесены из SimpleSelectInput при добавлении того же механизма в мультиселект —
// один источник правды на оба селекта.

// Проверка HEX-цвета
export const isValidHexColor = (color: string) => {
  if (!color || typeof color !== 'string') return false;
  return /^#([0-9A-F]{3}|[0-9A-F]{6})$/i.test(color);
};

// Компонент цветового индикатора
export const ColorSwatch = ({ color, size = 14, shape = 'square' }: {
  color?: string;
  size?: number;
  shape?: 'square' | 'circle';
}) => {
  const isValid = isValidHexColor(color);
  const borderRadius = shape === 'circle' ? '50%' : '3px';
  const style = {
    display: 'inline-block',
    width: size,
    height: size,
    borderRadius,
    backgroundColor: isValid ? color : 'transparent',
    border: isValid ? 'none' : '1px dashed #ccc',
    flexShrink: 0,
    marginRight: '8px',
  };
  return <span style={ style } />;
};
